var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contratos',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaDetalhar":"Gescon_Gestores_Contratos_Detalhar","rotaListagem":"Gescon_Gestores_Contratos","permiteDetalhar":_vm.$temAcessoView('GESCON-GEST-CONT-00')}})
}
var staticRenderFns = []

export { render, staticRenderFns }